import { render, staticRenderFns } from "./ActionShareRequest.vue?vue&type=template&id=57b0f7b0&"
import script from "./ActionShareRequest.vue?vue&type=script&lang=js&"
export * from "./ActionShareRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports